import { Component, OnInit, OnDestroy } from '@angular/core';
import { Result } from "@zxing/library";
import { StaticDataService } from "../../_services/generatedServices";
import { ToasterService } from "../../_services/toaster.service";
import { of } from "rxjs";
import { delay } from "rxjs/operators";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: 'bxl-wiba-layout',
  templateUrl: 'scanner.component.html',
})
export class ScannerComponent implements OnInit {
  initialized = false;
  value = ''
  color = '';
  private addonId: number;
  private eventId: number;


  constructor(private staticData: StaticDataService, private toasterService: ToasterService, private route: ActivatedRoute) {}


  public ngOnInit() {
    this.route.queryParamMap.subscribe((params) => {
      this.addonId = +params.get('addOnId');
      this.eventId = +params.get('eventId');

      console.log(this.eventId);
    });
  }


  public scan($event: Result) {
    console.log($event);
    if ($event == null) {
      return;
    }
    this.value = JSON.parse($event.getText()).UserId;

    var subscription = this.eventId ? this.staticData.verifyEventPurchase(+this.value, this.eventId) : this.staticData.verifyAddonPurchase(+this.value, this.addonId);

    subscription.subscribe((result) => {

      if (result) {
        this.color = 'green';
      } else {
        this.color = 'red';
      }

      of(null)
        .pipe(delay(3000))
        .subscribe((result) => {
          this.color = '';
        });
    });
  }
}
